import { REDUCER_KEY } from "./propertyAmenity.constants";
export var getByPropertyId = function (state, propertyId) {
    var _a, _b;
    if (!propertyId)
        return undefined;
    return (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.byPropertyId[propertyId]) === null || _b === void 0 ? void 0 : _b.items;
};
export var isFetchingByPropertyId = function (state, propertyId) {
    var _a, _b;
    if (!propertyId)
        return false;
    return ((_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.byPropertyId[propertyId]) === null || _b === void 0 ? void 0 : _b.isFetching) || false;
};
export var fetchErrorByPropertyId = function (state, propertyId) {
    var _a, _b;
    if (!propertyId)
        return undefined;
    return (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.byPropertyId[propertyId]) === null || _b === void 0 ? void 0 : _b.fetchError;
};
